import { Optional } from "common/utils/types";

/** matches OnboardingEventKind */
export const OnboardingClientEventKind = {
  LinkSending: "LINK_SENDING",
  ReminderLinkSending: "REMINDER_LINK_SENDING",
  LinkSent: "LINK_SENT",
  LinkFailedToSend: "LINK_FAILED_TO_SEND",
  LinkOpened: "LINK_OPENED",
  LinkSubmitted: "LINK_SUBMITTED",
  Called: "CALLED",
  Scheduled: "SCHEDULED",
  LegacyPharmacyLinkClicked: "LEGACY_PHARMACY_LINK_CLICKED",
  Note: "NOTE",
} as const;
export type OnboardingClientEventKind =
  (typeof OnboardingClientEventKind)[keyof typeof OnboardingClientEventKind];

/** Matches CommonOnboardingEventProfileSerializer */
export interface OnboardingEventProfile {
  id: number;
  full_name: string;
}

/** matches CommonOnboardingEventSerializer */
export interface OnboardingEvent {
  id: number;
  kind: OnboardingClientEventKind;
  note: Optional<string>;
  acting_user: Optional<OnboardingEventProfile>;
  is_client_action: boolean;
  created: string;
}
